/* Ashdeco V3 (ahm3): header (menu danh muc, tim kiem, ngan keo dien thoai, trang thai cuon) va cac tab "Find your signature piece".
   Khong phu thuoc thu vien. Ton trong prefers-reduced-motion. Chi chay tren cac khoi .ahm3. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  function qs(s, c) { return (c || d).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  /* ---------- HEADER ---------- */
  var nav = qs('[data-a3-nav]');
  if (nav) {
    var hero = qs('[data-a3-hero]'); var solid = !!nav.closest('.ahm3-hdr--solid');
    var scope = nav.closest('[data-a3-root]') || d;
    var panels = { mega: qs('[data-a3-panel="mega"]', nav), search: qs('[data-a3-panel="search"]', nav), drawer: qs('[data-a3-panel="drawer"]', scope) };
    var toggles = {}; qsa('[data-a3-toggle]', nav).forEach(function (b) { toggles[b.getAttribute('data-a3-toggle')] = b; });
    var hoverTimer = null, lastFocus = null, pinned = { mega: false, search: false, drawer: false };

    function isOpen(k) { return panels[k] && !panels[k].hidden; }
    function setOpen(k, open) {
      var p = panels[k], t = toggles[k]; if (!p) return;
      p.hidden = !open; if (!open) pinned[k] = false; if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (k === 'drawer') { root.classList.toggle('ahm3-lock', open); nav.classList.toggle('is-drawer', open); }
      nav.classList.toggle('is-open', isOpen('mega') || isOpen('search') || isOpen('drawer'));
    }
    function closeAll(except) { ['mega', 'search', 'drawer'].forEach(function (k) { if (k !== except && isOpen(k)) setOpen(k, false); }); }

    Object.keys(toggles).forEach(function (k) {
      toggles[k].addEventListener('click', function () {
        /* bang mo do ro chuot: bam lan dau chi GHIM lai (khong dong); bam lan sau moi dong */
        if (k === 'mega' && isOpen('mega') && !pinned.mega) { pinned.mega = true; return; }
        var open = !isOpen(k); closeAll(k); setOpen(k, open); if (open) pinned[k] = true;
        if (open && k === 'search') { var i = qs('input[type=search]', panels.search); if (i) i.focus(); }
        if (open && k === 'drawer') { lastFocus = toggles.drawer; var f = qs(canHover ? 'input,summary,a' : 'summary,a', panels.drawer); if (f) f.focus(); } /* cam ung: khong focus o tim kiem, vi focus() trong su kien bam se bat ban phim tren iOS/Android */
        if (!open && k === 'drawer' && lastFocus) lastFocus.focus();
      });
    });
    /* mo bang hover tren may co chuot */
    if (toggles.mega && canHover) {
      var wrap = toggles.mega.parentNode;
      [toggles.mega, panels.mega].forEach(function (el) {
        el.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); closeAll('mega'); setOpen('mega', true); });
        el.addEventListener('mouseleave', function () { hoverTimer = setTimeout(function () { if (!pinned.mega) setOpen('mega', false); }, 180); });
      });
    }
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var was = ['mega', 'search', 'drawer'].filter(isOpen)[0]; if (!was) return;
        closeAll(); if (toggles[was]) toggles[was].focus();
      }
      if (e.key === 'Tab' && isOpen('drawer')) {
        var f = qsa('input,summary,a[href],button', panels.drawer).filter(function (x) { return x.offsetParent !== null; }).concat([toggles.drawer]);
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    function outside(e) { if (!nav.contains(e.target) && !panels.drawer.contains(e.target)) closeAll(); }
    d.addEventListener('click', outside); d.addEventListener('pointerdown', outside); /* pointerdown: Safari tren iPhone khong phat click len document khi cham vao phan tu khong bam duoc */
    /* Safari giu nguyen trang trong bo nho khi bam Back (bfcache): ngan keo/bang dang mo van mo, trang van bi khoa cuon. Dong het khi trang quay lai. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) closeAll(); });
    nav.addEventListener('focusout', function (e) { var n = e.relatedTarget; if (n && !nav.contains(n) && !panels.drawer.contains(n)) { setOpen('mega', false); setOpen('search', false); } });
    window.addEventListener('resize', function () { if (window.innerWidth >= 950 && isOpen('drawer')) setOpen('drawer', false); });

    /* trang thai cuon: thanh co dinh, doi sang nen dac khi roi khoi anh hero */
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () {
        var limit = solid ? 24 : (hero ? Math.max(120, hero.offsetHeight - 140) : 120); nav.classList.toggle('is-stuck', window.pageYOffset > limit); ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- TAB SAN PHAM ---------- */
  qsa('[data-a3-tabs]').forEach(function (box) {
    var tabs = qsa('[role=tab]', box), panes = qsa('[role=tabpanel]', box); if (!tabs.length || tabs.length !== panes.length) return;
    box.classList.add('is-js');
    function select(i, focus) {
      tabs.forEach(function (t, k) { var on = k === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.setAttribute('tabindex', on ? '0' : '-1'); t.classList.toggle('is-on', on); });
      panes.forEach(function (p, k) { p.hidden = k !== i; });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = null; if (e.key === 'ArrowRight') n = (i + 1) % tabs.length; else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length; else if (e.key === 'Home') n = 0; else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
    var start = tabs.findIndex ? tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; }) : 0; select(start < 0 ? 0 : start, false);
  });
})();

/* Huy hieu tren icon header: (1) tim = so san pham da luu (localStorage 'phr_wishlist', su kien window 'phr:wishlist:change' do nut tim o trang san pham, luoi collection, gio hang, trang tim kiem phat ra);
   (2) gio hang = so luong that cua gio (khoi gio hang va cua so Added to cart cap nhat cac phan tu [data-cart-count] bang textContent / style.display; dong bo hien an va nhan doc cho trinh doc man hinh). */
(function () {
  'use strict';
  var d = document;
  function qsa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function pop(el) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
  var WL = 'phr_wishlist', lastW = -1;
  function wlN() { try { var a = JSON.parse(localStorage.getItem(WL) || '[]'); return Array.isArray(a) ? a.length : 0; } catch (e) { return 0; } }
  function paintW(n) {
    qsa('[data-a3-wish-count]').forEach(function (el) { el.textContent = n > 99 ? '99+' : String(n); el.style.display = n > 0 ? '' : 'none'; if (lastW >= 0 && n > lastW) pop(el); });
    qsa('[data-a3-wish]').forEach(function (a) { a.setAttribute('aria-label', n > 0 ? 'Wishlist, ' + n + (n === 1 ? ' saved item' : ' saved items') : 'Wishlist'); });
    lastW = n;
  }
  window.addEventListener('phr:wishlist:change', function (e) { var n = e && e.detail && typeof e.detail.count === 'number' ? e.detail.count : wlN(); paintW(n); });
  window.addEventListener('storage', function (e) { if (e.key === WL || e.key === null) paintW(wlN()); });
  paintW(wlN());
  function cartN(el) { var n = parseInt((el.textContent || '').trim(), 10); return isFinite(n) ? n : 0; }
  function syncCart(el) {
    var n = cartN(el); var hidden = el.style.display === 'none';
    if (n > 0 && hidden) el.style.display = ''; else if (n < 1 && !hidden) el.style.display = 'none';
    qsa('[data-a3-cart]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
  }
  qsa('.ahm3-nav__count[data-cart-count]').forEach(function (el) {
    var last = cartN(el); syncCart(el);
    if ('MutationObserver' in window) new MutationObserver(function () { var n = cartN(el); syncCart(el); if (n > last && n > 0) pop(el); last = n; }).observe(el, { childList: true, characterData: true, subtree: true });
  });
})();

/* 79 (18/10): anh hong (404) trong than bai blog thi an di, khach khong thay bieu tuong anh hong va khoang trong.
   Chi trong .article-content > .prose. Chi an anh DA HONG (complete va naturalWidth 0, hoac su kien error); anh chua tai (lazy) khong dong toi.
   An luon khoi boc (p, div, a, figure...) neu khoi do khong con chu va khong con anh/khung nhung nao khac. Bo qua anh .svg. */
(function () {
  'use strict';
  function run() {
    var pr = document.querySelector('.article-content > .prose'); if (!pr) return;
    function hide(img) {
      if (img.hasAttribute('data-a3-broken')) return; img.setAttribute('data-a3-broken', '');
      var last = img, box = img.parentElement;
      while (box && box !== pr && box.textContent.replace(/\s+/g, '') === '' && box.querySelectorAll('img,iframe,video,object,embed').length === 1) { last = box; box = box.parentElement; }
      last.style.display = 'none';
    }
    var imgs = pr.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) (function (im) {
      if (/\.svg(\?|$)/i.test(im.getAttribute('src') || '')) return;
      im.addEventListener('error', function () { hide(im); });
      if (im.complete && im.getAttribute('src') && im.naturalWidth === 0) hide(im);
    })(imgs[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
